import { useMutation } from '@apollo/client'
import { Typography, ButtonBase, Button } from '@material-ui/core'
import RefreshIcon from '@material-ui/icons/Refresh'
import React from 'react'
import { toast } from 'react-toastify'

import { addJob } from '../../cache/jobs'
import { INVENTORY_RETRY_FAILED_ALLOCATION } from '../../graphql/inventoryAllocateAvailability'
import {
  formatDateRange,
  getTodayDate,
  gregorianToJalaaliWithHourMinuteAndSecond
} from '../../helpers/date'
import { addCommaToPrice } from '../../helpers/numbers'
import { getTranslate, lang } from '../../localization'
import { JobsType } from '../../mockData/jobs'
import { LocalizedLink } from '../../routes/localizedRoutes'
import { AllocationLog } from '../../types/inventoryAllocationLogs'
import StatusBox from './StatusBox'
import useStyles from './styles/AllocationHistoryTableRow.styles'

interface AllocationHistoryTableRowProps {
  data: AllocationLog
}

export const AllocationHistoryTableRow: React.FC<
  AllocationHistoryTableRowProps
> = ({ data }) => {
  const classes = useStyles()
  const [mutateFunction, { loading }] = useMutation(
    INVENTORY_RETRY_FAILED_ALLOCATION,
    {
      onCompleted: (response) => {
        if (response.retryFailedAllocation.trackingID) {
          const newJob: JobsType = {
            trackID: response.retryFailedAllocation.trackingID,
            creationDate: getTodayDate(),
            status: 'InProgress'
          }
          addJob(newJob)
          toast.info(
            getTranslate(
              `retry retryFailedAllocation job with tracking id ${response.retryFailedAllocation.trackingID} started`
            )
          )
        } else {
          throw new Error(getTranslate('Server error, please try again'))
        }
      },
      onError: (err) => toast.error(err.message)
    }
  )

  const onSave = () => {
    mutateFunction({
      variables: {
        requestID: data.requestID
      }
    })
  }
  return (
    <ButtonBase
      className={[classes.tableRow].join(' ')}
      component={LocalizedLink}
      to={`/allocate-history/${data.requestID}/details`}>
      <div>
        <Typography variant="body1" className={classes.textFont}>
          {data.userEmail}
        </Typography>
      </div>
      <div>
        <Typography variant="body1" className={classes.textFont}>
          {lang === 'fa'
            ? gregorianToJalaaliWithHourMinuteAndSecond(data.requestTime)
            : data.requestTime}
        </Typography>
      </div>
      <div>
        <Typography className={classes.textFont} variant="body1">
          {formatDateRange(
            data.allocationRange.from,
            data.allocationRange.to,
            lang
          )}
        </Typography>
      </div>
      <div>
        <Typography variant="body1" className={classes.textFont}>
          {data.channelName}
        </Typography>
      </div>
      <div>
        <Typography variant="body1" className={classes.textFont}>
          {data.accommodationName}
        </Typography>
      </div>
      <div>
        <Typography variant="body1" className={classes.textFont}>
          {data.roomTypeName}
        </Typography>
      </div>
      <div>
        <Typography variant="body1" className={classes.textFont}>
          {getTranslate(data.action)}
        </Typography>
      </div>
      <div>
        <Typography variant="body1" className={classes.textFont}>
          {addCommaToPrice(data.delta)}
        </Typography>
      </div>
      <div>
        <StatusBox status={data.status} />
      </div>

      <div>
        <Button
          disabled={!data.canRetry || loading}
          variant="outlined"
          onClick={onSave}
          startIcon={<RefreshIcon />}
          color="primary">
          {getTranslate('Retry')}
        </Button>
      </div>
    </ButtonBase>
  )
}
